import CardsSlider from "@features/landing/components/common/CardsSlider";
import FestivalBanner from "../spiral/banner";

import LandingStaticSliderList from "./StaticSliders";

import { homePageStaticSlidersData } from "@features/home/helpers/constants";
import { useAllProduct } from "../../hooks/useAllProduct";
import Collections from "./collections";

const PercentageFestivalAllProduct = () => {
  const { hasProducts, recommended, recent, favorite, isLogin } =
    useAllProduct();
  return (
    <section className="w-full flex flex-col gap-16 py-16">
      {homePageStaticSlidersData.map((item, index) => (
        <div className="relative w-full" key={index}>
          <LandingStaticSliderList initialData={item} />
        </div>
      ))}

      <Collections disableShowMore className="mb-0" />

      {isLogin && hasProducts(recommended) && (
        <CardsSlider
          viewAllLink="/my-account/recommended"
          {...recommended!.data}
        />
      )}

      {isLogin && hasProducts(favorite) && (
        <CardsSlider viewAllLink="/my-account/wishlist" {...favorite!.data} />
      )}

      <FestivalBanner />

      {isLogin && hasProducts(recent) && (
        <CardsSlider viewAllLink="/recently-viewed" {...recent!.data} />
      )}
    </section>
  );
};

export default PercentageFestivalAllProduct;
